module.exports = __webpack_public_path__ + "static/media/UmrahLeave.b3b39936.svg";